import React from 'react'
import Page from '../Page'

const IS = ({ testResult }) => {
    return (
        <>
            <Page
                testResult={testResult}
                title="معرفی الگوی رفتاری IS"
            >
                <div className='text-gray-800 leading-7'>
                    افراد با الگوی  IS ترکیبی دل‌نشین از اجتماعی بودن، شادابی، آرامش و حمایت‌گری هستند. این افراد ذاتاً همدل، خونگرم، خوش‌برخورد و علاقمند به روابط انسانی هستند. آن‌ها به دنبال ایجاد پیوندهای عمیق و با‌دوام با اطرافیان هستند و ترجیح می‌دهند در محیطی با همدلی بالا، ارتباط مثبت و بدون درگیری فعالیت کنند.
                </div>

                <div className='text-gray-800 leading-7'>
                    ویژگی شاخص آن‌ها، نیاز به پذیرش اجتماعی و تلاش برای اجتناب از تنش‌هاست. این افراد اغلب با لبخند، خوش‌رویی و رفتار حمایت‌گرانه در دل دیگران جا باز می‌کنند و سعی می‌کنند در تیم نقش "چسب ارتباطی" را ایفا کنند؛ کسی که فضا را گرم و دوستانه نگه می‌دارد.
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="خلاصه ویژگی‌های کلیدی ISها"
            >
                <div className='text-gray-800 leading-7'>
                    <div className='text-gray-800 leading-7 overflow-x-auto'>
                        <table className='table-auto border-collapse border border-gray-300 w-full text-right'>
                            <thead>
                                <tr className='bg-gray-100'>
                                    <th className='border border-gray-300 px-4 py-2'>ویژگی‌ها</th>
                                    <th className='border border-gray-300 px-4 py-2'>شرح</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className='border border-gray-300 px-4 py-2'>سبک ارتباط</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        گرم، دوستانه، همدلانه، مؤدب
                                    </td>
                                </tr>
                                <tr className='bg-gray-50'>
                                    <td className='border border-gray-300 px-4 py-2'>اولویت</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        رضایت اطرافیان و حفظ روابط مثبت
                                    </td>
                                </tr>
                                <tr>
                                    <td className='border border-gray-300 px-4 py-2'>نقاط قوت</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        وفاداری، ارتباطات انسانی قوی، حمایت‌گری، ثبات رفتاری
                                    </td>
                                </tr>
                                <tr className='bg-gray-50'>
                                    <td className='border border-gray-300 px-4 py-2'>چالش‌ها</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        سخت نه گفتن، اجتناب از تعارض، تمرکز کمتر بر نتیجه و سرعت
                                    </td>
                                </tr>
                                <tr>
                                    <td className='border border-gray-300 px-4 py-2'>محیط ایده‌آل</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        گرم، انسانی، فاقد فشار زیاد، ساختار یافته اما نه خشک
                                    </td>
                                </tr>
                                <tr className='bg-gray-50'>
                                    <td className='border border-gray-300 px-4 py-2'>در تصمیم‌گیری</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        نیاز به زمان و حمایت عاطفی، و ترجیح به اجماع گروهی
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="مثال کاربردی"
            >
                <div className='text-gray-800 leading-7 space-y-4 text-right'>
                    <p>
                        در یک تیم کاری، فرد <strong>IS</strong> همان کسی است که تولدها را یادآوری می‌کند،
                        با لطافت به تعارض‌ها پایان می‌دهد و حواسش به حال‌وهوای روحی اعضای تیم هست.
                        اگر کسی ناراحت باشد، خیلی زود متوجه می‌شود.
                    </p>

                    <p>
                        در جلسات، تلاش می‌کند همه را در گفتگو مشارکت دهد،
                        حرف کسی را قطع نمی‌کند و اگر قرار باشد انتقادی مطرح کند،
                        آن را با احترام و ملایمت بیان می‌کند.
                    </p>

                    <div className='pt-2'>
                        <p className='font-semibold'>
                            پیشنهاد فیلم برای درک بهتر الگوی IS:
                        </p>

                        <p className='mt-2'>
                            <span className='italic'>"The Blind Side"</span>
                            <span className='mx-2'>—</span>
                            نقطه کور
                        </p>

                        <p className='mt-2'>
                            شخصیت «لی آن توهی» با بازی ساندرا بولاک،
                            نمونه‌ای از فردی با ویژگی‌های تیپ <strong>IS</strong> است؛
                            مهربان، حمایت‌گر و اجتماعی، اما در عین حال با ثبات در تصمیم‌گیری
                            برای کمک به دیگران و ساختن فضایی امن.
                        </p>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="ابعاد و توصیف ویژگی‌های رفتاری IS"
            >
                <div className='text-gray-800 leading-7'>
                    افراد دارای تیپ  IS ترکیبی از روابط‌محوری و ثبات رفتاری هستند. آن‌ها در موقعیت‌های اجتماعی خوش‌درخشند، از بودن در کنار دیگران انرژی می‌گیرند و در عین حال، به آرامش، هماهنگی و تداوم روابط اهمیت زیادی می‌دهند. این افراد برای حفظ محیطی با حداقل تنش و حداکثر صمیمیت تلاش می‌کنند.
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="ویژگی‌های اصلی تیپ IS"
            >
                <div className='text-gray-800 leading-7 space-y-6 text-right'>

                    <div className='space-y-2'>
                        <h3 className='font-bold'>1. روابط‌محوری</h3>
                        <p>
                            فرد <strong>IS</strong> انرژی اصلی خود را از تعامل با دیگران دریافت می‌کند.
                            او شنونده‌ای خوب، مشتاق به گفتگو، تشویق‌کننده و اهل روابط مثبت است.
                            دوست دارد در جمع بدرخشد، اما نه به شکل خودنمایی؛
                            بلکه با لطافت، همراهی و ایجاد حس خوب در دیگران.
                        </p>
                    </div>

                    <div className='space-y-2'>
                        <h3 className='font-bold'>2. ثبات و آرامش</h3>
                        <p>
                            این افراد معمولاً هیجان‌زده یا آشفته نمی‌شوند.
                            در شرایط سخت تلاش می‌کنند امنیت روانی اطرافیان را حفظ کنند.
                            آن‌ها مانند یک آهنربای آرامش عمل می‌کنند و در دل دیگران حس امنیت ایجاد می‌کنند.
                        </p>
                    </div>

                    <div className='space-y-2'>
                        <h3 className='font-bold'>3. پرهیز از تعارض</h3>
                        <p>
                            <strong>IS</strong>ها اغلب از درگیری پرهیز می‌کنند.
                            حتی اگر لازم باشد احساسات خود را پنهان کنند یا کوتاه بیایند،
                            ترجیح می‌دهند فضای آرام باقی بماند.
                            این موضوع می‌تواند باعث شود نارضایتی خود را به‌موقع بیان نکنند.
                        </p>
                    </div>

                    <div className='space-y-2'>
                        <h3 className='font-bold'>4. اعتمادپذیری و وفاداری</h3>
                        <p>
                            دوستان و همکاران آن‌ها را افرادی قابل‌اعتماد می‌دانند.
                            قولی را که می‌دهند تا حد امکان عملی می‌کنند
                            و در روابط به‌ندرت دمدمی یا متغیر هستند.
                        </p>
                    </div>

                    <div className='space-y-2'>
                        <h3 className='font-bold'>5. نیاز به تأیید اجتماعی</h3>
                        <p>
                            آن‌ها دوست دارند مورد تأیید و تشویق قرار بگیرند.
                            حس ارزشمندی‌شان تا حدی وابسته به بازخورد مثبت دیگران است.
                        </p>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
            >
                <div className='text-gray-800'>

                    <div className='space-y-3 pt-4'>
                        <h3 className='font-bold'>نکات کاربردی</h3>
                        <ul className='list-disc pr-5 space-y-2'>
                            <li>اگر یک فرد <strong>IS</strong> در تیم شماست، از او برای آرام کردن فضاهای پرتنش استفاده کنید.</li>
                            <li>در مواجهه با تغییرات ناگهانی یا فشارهای زیاد، ممکن است مضطرب شود؛ برایش امنیت روانی ایجاد کنید.</li>
                            <li>آن‌ها عاشق بازخورد مثبت‌اند؛ یک تحسین ساده می‌تواند انگیزه‌ای بزرگ برایشان باشد.</li>
                            <li>نه گفتن برایشان دشوار است؛ گاهی لازم است از آن‌ها حمایت کنید تا قاطع‌تر باشند.</li>
                        </ul>
                    </div>

                    <div className='space-y-2 pt-4'>
                        <h3 className='font-bold'>فیلم پیشنهادی</h3>
                        <p>
                            <span className='italic'>Julie & Julia (2009)</span> —
                            شخصیت «جولی» نمونه‌ای از یک فرد <strong>IS</strong> است:
                            اجتماعی، همدل و مشتاق ارتباط با دیگران،
                            اما در عین حال به دنبال مسیری آرام و پایدار برای بروز خلاقیت خود.
                        </p>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="تشریح الگوی رفتاری IS"
            >
                <div className='text-gray-800 leading-7'>
                    فرد  IS یعنی فردی با تأثیرگذاری بالا و ثبات رفتاری زیاد. او ترکیبی دلنشین از مهربانی، ارتباط‌گرایی، آرامش‌طلبی و وفاداری است. این افراد نه مثل High D ها دنبال قدرت‌اند، نه مثل High C ها درگیر تحلیل، نه مثل High I ها کاملاً هیجانی و نه مثل High S ها صرفاً محافظه‌کار. آن‌ها «نیم‌کره‌ی گرم و امن گروه» هستند: با دیگران می‌جوشند، اما با آرامش رفتار می‌کنند.

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="الگوی IS در رفتارهای روزمره"
            >
                <div className='text-gray-800 leading-7'>
                    <div className='text-gray-800 leading-7 overflow-x-auto'>
                        <table className='table-auto border-collapse border border-gray-300 w-full text-right'>
                            <thead>
                                <tr className='bg-gray-100'>
                                    <th className='border border-gray-300 px-4 py-2'>زمینه</th>
                                    <th className='border border-gray-300 px-4 py-2'>رفتار IS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        گفتار
                                    </td>
                                    <td className='border border-gray-300 px-4 py-2'>محترمانه، دلنشین، همراه با شوخ‌طبعی نرم</td>
                                </tr>
                                <tr className='bg-gray-50'>
                                    <td className='border border-gray-300 px-4 py-2'>واکنش به چالش</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        محافظه‌کارانه، ابتدا با تأمل و سپس اقدام

                                    </td>
                                </tr>
                                <tr>
                                    <td className='border border-gray-300 px-4 py-2'>در جمع</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        گرم و همراه، اما نه لزوماً لیدر یا کانون توجه
                                    </td>
                                </tr>
                                <tr className='bg-gray-50'>
                                    <td className='border border-gray-300 px-4 py-2'>در تنهایی</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        کمی بی‌انرژی، ممکن است حس تنهایی کند
                                    </td>
                                </tr>
                                <tr>
                                    <td className='border border-gray-300 px-4 py-2'>در بحران</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        سعی در آرام‌سازی اطرافیان دارد، اما خودش دچار فشار درونی می‌شود
                                    </td>
                                </tr>
                                <tr className='bg-gray-50'>
                                    <td className='border border-gray-300 px-4 py-2'>در کار تیمی</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        عالی در پیوند اعضا، اما نیاز به حمایت برای گرفتن تصمیمات مهم
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=" رفتارهای قابل مشاهده"
            >
                <div className='text-gray-800 leading-7 space-y-6 text-right'>

                    <div className='space-y-3'>
                        <ul className='list-disc pr-5 space-y-2'>
                            <li>هنگام تعارض ترجیح می‌دهد فضا را ترک کند تا تنش ایجاد نشود.</li>
                            <li>در زمان نیاز، ابتدا به دیگران کمک می‌کند و بعد به خودش می‌رسد.</li>
                            <li>اگر به او بگویند «تو باعث دلگرمی ما هستی»، احساس مفید بودن عمیقی می‌گیرد.</li>
                            <li>اگر چند روز ارتباط گرم با او نداشته باشید، درونی می‌رنجَد اما چیزی بیان نمی‌کند.</li>
                            <li>در سازمان برای حفظ جو مثبت بسیار مهم است، حتی اگر نقش مدیریتی نداشته باشد.</li>
                        </ul>
                    </div>

                    <div className='space-y-4 pt-4'>
                        <h3 className='font-bold'>مثال سناریویی</h3>

                        <p>
                            فرض کنید در یک جلسه کاری، پروژه‌ای دچار بحران شده است:
                        </p>

                        <ul className='space-y-2 pr-5'>
                            <li><strong>High D</strong> می‌گوید: «چرا کار جلو نرفته؟ باید سریع تعیین تکلیف کنیم!»</li>
                            <li><strong>High C</strong> می‌گوید: «باید گزارش کامل تهیه شود تا ببینیم دقیقاً کجا اشتباه کردیم.»</li>
                            <li><strong>High I</strong> شاید بگوید: «یه ایده خفن دارم که روحیه‌مون رو هم بالا می‌بره!»</li>
                            <li>
                                اما فرد <strong>IS</strong> احتمالاً خواهد گفت:
                                «بچه‌ها مهمه که اول با هم ارتباط خوبی داشته باشیم.
                                الان همه کمی فشار رو حس می‌کنن.
                                بذارید فضا رو آروم‌تر کنیم و بعد دوباره جمع‌بندی کنیم...»
                            </li>
                        </ul>

                        <p className='pt-3'>
                            در واقع <strong>IS</strong> مثل یک پتو در سرمای تیم عمل می‌کند؛
                            گرما می‌دهد، بی‌آنکه جلب توجه کند.
                        </p>
                    </div>

                    <div className='text-gray-800 leading-7 text-right'>
                        <ul className='list-disc pr-5 space-y-2'>
                            <li>شخصیت IS، دوست‌داشتنی، انسانی، وفادار، و آرام است</li>
                            <li>نقاط قوت: ارتباط گرم، وفاداری، حمایت‌گری، شنونده بودن</li>
                            <li>نقاط چالش‌برانگیز: تصمیم‌گیری کند، حساسیت بالا به طرد شدن، اجتناب از تعارض</li>
                            <li>نیازمند امنیت، بازخورد مثبت، و احترام رفتاری است</li>
                        </ul>
                    </div>

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="انگیزه‌های رفتاری افراد با الگوی IS"
            >
                <div className='text-gray-800 leading-7'>
                    *چه چیزی فرد  IS را به حرکت وامی‌دارد؟
                    افراد  IS انگیزه‌هایشان عموماً نه از جنس قدرت‌طلبی یا نتیجه‌گرایی محض، بلکه از جنس روابط انسانی، تعامل مثبت، و حس پذیرش اجتماعی است. آن‌ها اگر احساس کنند که دوست‌داشتنی هستند، در جمع پذیرفته می‌شوند و حضورشان برای دیگران مفید است، با قدرت درونی بی‌نظیری وارد میدان می‌شوند.

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="مهم‌ترین محرک‌های انگیزشی برای ISها"
            >
                <div className='text-gray-800 leading-7'>
                    <div className='text-gray-800 leading-7 overflow-x-auto'>
                        <table className='table-auto border-collapse border border-gray-300 w-full text-right'>
                            <thead>
                                <tr className='bg-gray-100'>
                                    <th className='border border-gray-300 px-4 py-2'>انگیزه</th>
                                    <th className='border border-gray-300 px-4 py-2'>شرح</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className='border border-gray-300 px-4 py-2'>حس تعلق</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        زمانی بهترین عملکرد را دارند که بدانند عضوی ارزشمند در یک گروه هستند.
                                    </td>
                                </tr>
                                <tr className='bg-gray-50'>
                                    <td className='border border-gray-300 px-4 py-2'>قدردانی و بازخورد مثبت</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        حتی یک "دست‌مریزاد" ساده از سوی مدیر یا همکار، برایشان انرژی‌بخش است.
                                    </td>
                                </tr>
                                <tr>
                                    <td className='border border-gray-300 px-4 py-2'>رابطه عاطفی مثبت</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        داشتن روابط پایدار، گرم و بدون تعارض بزرگ‌ترین منبع آرامش آن‌هاست.
                                    </td>
                                </tr>
                                <tr className='bg-gray-50'>
                                    <td className='border border-gray-300 px-4 py-2'>فرصت حمایت از دیگران</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        وقتی بتوانند مفید باشند، انگیزه‌شان افزایش می‌یابد.
                                    </td>
                                </tr>
                                <tr>
                                    <td className='border border-gray-300 px-4 py-2'>محیط باثبات و قابل پیش‌بینی</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        تغییرات ناگهانی و تصمیمات تند می‌تواند آن‌ها را از پا دربیاورد.
                                    </td>
                                </tr>
                                <tr className='bg-gray-50'>
                                    <td className='border border-gray-300 px-4 py-2'>شور و نشاط گروهی</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        در فضاهای گرم و دوستانه، مثل گل می‌درخشند.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="رفتارهای نشانه‌دار وقتی انگیزه دارند"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='list-disc pr-5 space-y-2'>
                        <li>داوطلب می‌شوند در کارهای تیمی یا حمایتی مشارکت کنند</li>
                        <li>روحیه‌شان بالا می‌رود، بیشتر لبخند می‌زنند</li>
                        <li>احساس تعلق آن‌ها به سازمان یا خانواده عمیق‌تر می‌شود</li>
                        <li>وقتی ببینند تلاششان "دیده شده"، باز هم با اشتیاق ادامه می‌دهند</li>
                        <li>تمایل دارند روابط را صمیمانه‌تر کنند</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="و زمانی که بی‌انگیزه‌اند..."
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='list-disc pr-5 space-y-2'>
                        <li>سکوت می‌کنند، اما از درون دلخورند</li>
                        <li>احساس بی‌ارزشی دارند</li>
                        <li>ترجیح می‌دهند کنار بروند و وارد بحث نشوند</li>
                        <li>اگر احساس طرد یا بی‌توجهی کنند، از نظر عملکردی افت می‌کنند</li>
                        <li>گاهی برای راضی نگه داشتن دیگران، خود را قربانی می‌کنند</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="راهکارهای انگیزش برای مدیران، مربیان یا اطرافیان یک  IS"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='list-decimal pr-5 space-y-2'>
                        <li>مرتباً بازخورد مثبت، صمیمی و واقعی بدهید.</li>
                        <li>او را در جمع تحسین کنید، اما بدون فشار.</li>
                        <li>نشان دهید که رفتارهای همدلانه او چقدر برای تیم ارزش دارد.</li>
                        <li>در برابر رفتارهای حمایتی‌اش، از او قدردانی کنید.</li>
                        <li>محیطی با روابط انسانی سالم برای او بسازید.</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="عادت‌های کاری شما در تیپ   IS"
            >
                <div className='text-gray-800 leading-7'>
                    افراد با الگوی  IS در محیط کاری معمولاً محبوب، سازگار و حامی هستند. آن‌ها تلاش می‌کنند تا با ایجاد فضای گرم و همدلانه، روح تیمی را تقویت کرده و تنش‌ها را کاهش دهند. کار کردن با آن‌ها ساده است، چون آرام، مؤدب، منظم و اهل همکاری‌اند. اما ممکن است گاهی برای تصمیم‌گیری یا اولویت‌بندی، نیاز به راهنمایی داشته باشند.
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=" ویژگی‌های اصلی کاری ISها"
            >
                <div className='text-gray-800 leading-7'>
                    <div className='text-gray-800 leading-7 overflow-x-auto'>
                        <table className='table-auto border-collapse border border-gray-300 w-full text-right'>
                            <thead>
                                <tr className='bg-gray-100'>
                                    <th className='border border-gray-300 px-4 py-2'>ویژگی</th>
                                    <th className='border border-gray-300 px-4 py-2'>شرح</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className='border border-gray-300 px-4 py-2'>همکاری‌جو</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        همیشه به دنبال مشارکت مثبت‌اند. اگر احساس کنند در حاشیه قرار گرفته‌اند، ممکن است ناراحت شوند.
                                    </td>
                                </tr>
                                <tr className='bg-gray-50'>
                                    <td className='border border-gray-300 px-4 py-2'>سازمان‌دهی‌شده</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        اگرچه خیلی ساختارمند نیستند، اما با ثبات پیش می‌روند و به روندهای کاری وفادار می‌مانند.
                                    </td>
                                </tr>
                                <tr>
                                    <td className='border border-gray-300 px-4 py-2'>تمایل به کمک</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        اگر کاری برای همکار انجام ندهند، احساس گناه می‌کنند! کمک به دیگران بخشی از هویت کاری آن‌هاست.
                                    </td>
                                </tr>
                                <tr className='bg-gray-50'>
                                    <td className='border border-gray-300 px-4 py-2'>اجتناب از تعارض</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        ترجیح می‌دهند اختلافات را در نطفه خنثی کنند، حتی اگر حق با آن‌ها باشد.
                                    </td>
                                </tr>
                                <tr>
                                    <td className='border border-gray-300 px-4 py-2'>نیاز به زمان بیشتر</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        برای انجام کارهای جدید یا چالش‌برانگیز نیاز به فضای امن و زمان کافی دارند.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="نقاط قوت در محیط کاری"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='list-disc pr-5 space-y-2'>
                        <li>باعث تقویت فضای همدلانه و دوستانه در تیم می‌شوند</li>
                        <li>در روابط بین‌فردی بسیار موفق‌اند</li>
                        <li>در نقش‌های پشتیبانی، خدمات مشتری، منابع انسانی، آموزش و مشاوره می‌درخشند</li>
                        <li>وفاداری بالا دارند و اهل ترک سازمان نیستند</li>
                        <li>وقتی از آن‌ها حمایت شود، می‌توانند مؤثرترین افراد در نگه‌داشت تیم باشند</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="چالش‌های رفتاری"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='list-disc pr-5 space-y-2'>
                        <li>ممکن است به خاطر نگرانی از ناراحت کردن دیگران، "نه" نگویند</li>
                        <li>گاهی بیش از حد احساس مسئولیت می‌کنند</li>
                        <li>در تصمیم‌گیری سریع و اولویت‌بندی دچار کندی می‌شوند</li>
                        <li>به خاطر اجتناب از تنش، ممکن است نارضایتی‌ها را پنهان کنند</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="راهکارهایی برای بهره‌گیری بهتر از ISها در سازمان"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='list-decimal pr-5 space-y-2'>
                        <li>نقش‌هایی به آن‌ها بدهید که در آن با دیگران تعامل انسانی دارند.</li>
                        <li>به آن‌ها فرصت بدهید تا با تغییرات سازگار شوند.</li>
                        <li>برایشان مرز تعیین کنید تا بیش‌از‌حد خود را قربانی نکنند.</li>
                        <li>در جلسات، با احترام از آن‌ها بخواهید نظر بدهند، چون ممکن است صبر کنند تا کسی از آن‌ها بخواهد.</li>
                        <li>برای پیاده‌سازی ایده‌های خلاقانه، از مشارکت احساسی و گروهی‌شان استفاده کنید.</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="دیدگاه‌های شما در تیپ IS"
            >
                <div className='text-gray-800 leading-7'>
                    افراد  IS به دلیل ترکیب منحصربه‌فرد تأثیرگذاری بالا I  و ثبات بالا S، معمولاً جهان را با چشمانی مهربان، خوش‌بین و آرام نگاه می‌کنند. آن‌ها دوست دارند دیگران را شاد ببینند، در جمع احساس پذیرش داشته باشند، و آرامش و رضایت اطرافیان را مهم‌تر از سرعت و رقابت می‌دانند.
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=" دیدگاه ISها نسبت به خودشان"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='list-disc pr-5 space-y-2'>
                        <li>معمولاً تصویر مثبتی از خود دارند، مخصوصاً در حوزه روابط انسانی</li>
                        <li>احساس می‌کنند «آدم‌های خوبی هستند» که دیگران می‌توانند روی آن‌ها حساب کنند</li>
                        <li>اگر بازخورد منفی دریافت کنند، به‌جای خشم، احساس گناه یا دلسردی می‌کنند</li>
                        <li>خود را بیشتر «پشتیبان تیم» می‌دانند تا رهبر یا مدیر</li>
                        <li>ممکن است به توانمندی‌های فردی خود کمتر از آنچه هست امتیاز بدهند</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=" دیدگاه نسبت به دیگران"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='list-disc pr-5 space-y-2'>
                        <li>دیگران را بالقوه خوب، دوست‌داشتنی و قابل احترام می‌دانند</li>
                        <li>ترجیح می‌دهند درباره افراد قضاوت نکنند</li>
                        <li>وقتی کسی را با لحن یا رفتار تند مواجه می‌سازد، به‌شدت ناراحت می‌شوند، حتی اگر به آن‌ها مربوط نباشد</li>
                        <li>به راحتی به دیگران اعتماد می‌کنند؛ گاهی حتی بیش از حد</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="دیدگاه نسبت به کار و محیط کاری"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='list-disc pr-5 space-y-2'>
                        <li>کار را وسیله‌ای برای معنا، ارتباط انسانی، و مشارکت جمعی می‌دانند</li>
                        <li>سرعت و رقابت برایشان اضطراب‌آور است، در حالی که همکاری و رضایت جمعی انگیزه‌بخش است</li>
                        <li>تغییرات سریع، قوانین خشک، و فرهنگ رقابتی شدید، می‌تواند انگیزه‌شان را کاهش دهد</li>
                        <li>دوست دارند کار را به گونه‌ای انجام دهند که هم نتیجه بدهد، هم احساس خوبی منتقل کند</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="دیدگاه نسبت به زندگی"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='list-disc pr-5 space-y-2'>
                        <li>زندگی را ترکیبی از همدلی، همراهی، و خاطره‌سازی‌های انسانی می‌دانند</li>
                        <li>اهمیت زیادی به روابط خانوادگی، دوستی‌های عمیق، و محیط‌های گرم و امن می‌دهند</li>
                        <li>معتقدند که هر کس باید سهمی در خوشحال کردن دیگران داشته باشد</li>
                        <li>به ندرت دیدگاه‌های انتقادی یا بدبینانه دارند</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="نکته مدیریتی"
            >
                <div className='text-gray-800 leading-7'>
                    اگر فردی  IS در تیم دارید، با او مثل یک انسان حساس و محترم رفتار کنید، نه یک چرخ‌دنده در سیستم. به او اعتماد کنید، تحسینش کنید، و در تصمیمات مشارکتش دهید. خواهید دید که او چطور با وفاداری، تلاش، و اخلاق‌مداری به موفقیت تیم خدمت می‌کند.
                </div>
            </Page>


            <Page
                testResult={testResult}
                title="اوقات فراغت در تیپ IS"
            >
                <div className='text-gray-800 leading-7'>
                    افراد  IS در اوقات فراغت خود به دنبال آرامش، ارتباطات صمیمی، و فعالیت‌هایی با بار عاطفی مثبت هستند. نه به دنبال هیجان شدیدند، نه به انزوا علاقه دارند؛ بلکه ترجیح می‌دهند در فضایی گرم، دوستانه و آرام، زمان خود را با کسانی که دوستشان دارند سپری کنند.
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=" ویژگی‌های اصلی اوقات فراغت ISها"
            >
                <div className='overflow-x-auto'>
                    <table className='table-auto border border-gray-300 text-right'>
                        <thead>
                            <tr className='bg-gray-100'>
                                <th className='border px-4 py-2'>جنبه</th>
                                <th className='border px-4 py-2'>ترجیحات فرد IS</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className='even:bg-gray-50'>
                                <td className='border px-4 py-2'>نوع فعالیت‌ها</td>
                                <td className='border px-4 py-2'>تعامل‌محور، خلاقانه، آرام‌بخش، لذت‌بخش و گاهی نوستالژیک</td>
                            </tr>
                            <tr className='even:bg-gray-50'>
                                <td className='border px-4 py-2'>با چه کسانی؟</td>
                                <td className='border px-4 py-2'>دوستان نزدیک، اعضای خانواده، همکاران صمیمی یا گروه‌های اجتماعی کوچک</td>
                            </tr>
                            <tr className='even:bg-gray-50'>
                                <td className='border px-4 py-2'>مکان مورد علاقه</td>
                                <td className='border px-4 py-2'>طبیعت، کافه‌های آرام، خانه‌های دوستان، مکان‌های آشنا و امن</td>
                            </tr>
                            <tr className='even:bg-gray-50'>
                                <td className='border px-4 py-2'>محتوای مورد علاقه</td>
                                <td className='border px-4 py-2'>کتاب‌ها یا فیلم‌های الهام‌بخش، طنز ملایم، داستان‌های واقعی و احساسی</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="فعالیت‌هایی که افراد IS معمولاً لذت می‌برند"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='list-disc ml-5'>
                        <li>عکس گرفتن از لحظات خاص و به اشتراک گذاشتن با دوستان</li>
                        <li>رسیدگی به گل‌ها و گیاهان خانگی</li>
                        <li>کارهای هنری ملایم مثل طراحی، نقاشی یا دست‌سازه‌ها</li>
                        <li>دورهمی‌های ساده با دوستان یا خانواده</li>
                        <li>بازی‌های گروهی دوستانه و بدون فشار</li>
                        <li>گوش دادن به موسیقی آرام و انگیزشی</li>
                        <li>دیدن فیلم‌های احساسی یا انگیزشی با همراهان صمیمی</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="هشدار رفتاری"
            >
                <div className='text-gray-800 leading-7'>
                    <p>
                        اگر افراد IS در اوقات فراغت خود تنها بمانند، یا مجبور شوند با افراد پرتنش و محیط‌های پرسرعت وقت بگذرانند، احتمال احساس خستگی روانی، بی‌انگیزگی یا حتی گوشه‌گیری در آن‌ها بالا می‌رود.
                    </p>
                    <p>
                        به همین دلیل، باید حق انتخاب داشته باشند که با چه کسانی و در چه شرایطی وقت بگذرانند.
                    </p>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="نکته طلایی برای خانواده یا دوستان"
            >
                <div className='text-gray-800 leading-7'>
                    <p>اگر با یک فرد IS در سفر یا تفریح هستید، از او نخواهید که تصمیم سریع بگیرد یا ریسک‌های عجیب کند.</p>
                    <p>کافی است آرامش، امنیت و لبخند را برایش فراهم کنید.</p>
                    <p>او خودش شادی را برای جمع می‌سازد.</p>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="تصمیم‌گیری در تیپ IS"
            >
                <div className='text-gray-800 leading-7'>
                    <p>
                        تصمیم‌گیری برای افراد IS معمولاً با در نظر گرفتن دیگران، احساس مسئولیت اجتماعی، و پرهیز از تنش و پشیمانی همراه است.
                    </p>
                    <p>
                        آن‌ها هنگام انتخاب، ابتدا به این فکر می‌کنند که چه تأثیری بر روابطشان دارد؟
                        آیا کسی ناراحت نمی‌شود؟ آیا این تصمیم باعث ناهماهنگی نمی‌شود؟
                    </p>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="الگوی ذهنی ISها در تصمیم‌گیری"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='list-disc ml-5'>
                        <li>ملاحظه افراد درگیر در تصمیم</li>
                        <li>پرهیز از تعارض و اختلاف</li>
                        <li>تحلیل احساسی پیامدها</li>
                        <li>پرسیدن نظر دیگران به‌خصوص افراد مورد اعتماد</li>
                        <li>تأخیر در انتخاب برای سنجیدن همه گزینه‌ها</li>
                    </ul>
                </div>
            </Page>


            <Page
                testResult={testResult}
                title="نقاط قوت در تصمیم‌گیری
"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='list-disc ml-5'>
                        <li>تصمیم‌های اخلاق‌مدارانه و انسانی می‌گیرند</li>
                        <li>در تصمیم‌هایی که به رفاه و آرامش جمعی مربوط است، قابل اعتمادند</li>
                        <li>خیلی کم تصمیم عجولانه یا تک‌روانه می‌گیرند</li>
                        <li>اهل گوش دادن و مشورت‌اند</li>
                        <li>قبل از قضاوت یا تصمیم، تلاش می‌کنند حقیقت را کامل درک کنند</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="چالش‌های رفتاری"
            >
                <div className='text-gray-800 leading-7'>
                    <div className='text-gray-800 leading-7 overflow-x-auto'>
                        <table className='table-auto border-collapse border border-gray-300 w-full text-right'>
                            <thead>
                                <tr className='bg-gray-100'>
                                    <th className='border border-gray-300 px-4 py-2'>چالش</th>
                                    <th className='border border-gray-300 px-4 py-2'>شرح</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className='border border-gray-300 px-4 py-2'>تعلل</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        گاهی در گرفتن تصمیم نهایی، زمان زیادی صرف می‌کنند
                                    </td>
                                </tr>
                                <tr className='bg-gray-50'>
                                    <td className='border border-gray-300 px-4 py-2'>اجتناب از ریسک</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        اگر تصمیمی با تنش یا ریسک همراه باشد، عقب می‌نشینند
                                    </td>
                                </tr>
                                <tr>
                                    <td className='border border-gray-300 px-4 py-2'>تأثیرپذیری احساسی</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        ممکن است تصمیمی بگیرند که صرفاً کسی ناراحت نشود، نه اینکه بهترین گزینه باشد
                                    </td>
                                </tr>
                                <tr className='bg-gray-50'>
                                    <td className='border border-gray-300 px-4 py-2'>ناتوانی در "نه" گفتن</td>
                                    <td className='border border-gray-300 px-4 py-2'>
                                        برخی تصمیم‌ها را از سر اجبار یا دلسوزی می‌پذیرند
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="پیشنهادهایی برای بهبود تصمیم‌گیری در ISها"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='list-decimal pr-5 space-y-2'>
                        <li>فهرست گزینه‌ها و پیامدهای منطقی را بنویسند، نه فقط احساسی فکر کنند</li>
                        <li>از افراد با الگوهای D  یا C  در مسائل کاری و استراتژیک مشورت بگیرند</li>
                        <li>یاد بگیرند گاهی "نه" گفتن، نشانه محبت هوشمندانه است</li>
                        <li>یادآوری کنند که قرار نیست همه را راضی نگه دارند</li>
                        <li>برای تصمیم‌های کوچک، زمان و انرژی زیادی صرف نکنند</li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=" پیشنهاد فیلم"
            >
                <div className='text-gray-800 leading-7'>
                    <p>
                        "Finding Forrester" 2000 یافتن فارستر
                    </p>
                    <p className='mt-2'>
                        شخصیت جوان داستان با تیپ  IS برای آینده‌اش دچار شک و تعارض است، اما با یک رابطه انسانی سالم و اعتمادسازی، مسیر تصمیم‌گیری‌اش را پیدا می‌کند.
                    </p>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="پیشنهادات جهت بهبود عملکرد IS"
            >
                <div className='text-gray-800 leading-7'>
                    افراد  IS دارای ویژگی‌های انسانی فوق‌العاده‌ای هستند؛ اما اگر این ویژگی‌ها را به درستی تعدیل و جهت‌دهی نکنند، ممکن است دچار رکود، وابستگی یا استهلاک عاطفی شوند. آن‌ها برای اینکه به نسخه‌ای بالغانه، مستقل، کارآمد و مؤثر از خودشان تبدیل شوند، باید گام‌های زیر را بردارند:
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="پیشنهادات کاربردی و تقویت‌کننده"
            >
                <div className='text-gray-800 space-y-4'>
                    <div>
                        <h4 className='font-semibold mb-2'>1. جرئت‌مندی و نه‌گویی را تمرین کنید</h4>
                        <p>
                            شما لازم نیست همیشه بله بگویید. گاهی برای حفظ انرژی، مرزگذاری مؤدبانه ضروری است.
                        </p>
                    </div>
                    <div>
                        <h4 className='font-semibold mb-2'>2. در محیط‌های پرسرعت و چالش‌زا، به تدریج رشد کنید</h4>
                        <p>
                            کارهای رقابتی، اجرایی و پرشتاب را اول با حمایت دیگران تجربه کنید تا جسارتتان تقویت شود.
                        </p>
                    </div>
                    <div>
                        <h4 className='font-semibold mb-2'>3. خود را از حس گناه بی‌مورد رها کنید</h4>
                        <p>
                            کمک کردن خوب است، اما نه به قیمت فرسودگی یا نادیده گرفتن نیازهای خودتان.
                        </p>
                    </div>
                    <div>
                        <h4 className='font-semibold mb-2'>4. مدیریت زمان را تمرین کنید</h4>
                        <p>
                            چون تمایل دارید همه را راضی نگه دارید، ممکن است کارها روی هم تلنبار شوند. اولویت‌بندی یاد بگیرید.
                        </p>
                    </div>
                    <div>
                        <h4 className='font-semibold mb-2'>5. با افراد با تیپ D و C معاشرت هدفمند داشته باشید</h4>
                        <p>
                            برای تصمیم‌های قاطعانه، ساختارمند و تحلیلی از انرژی این افراد بهره‌مند شوید.
                        </p>
                    </div>
                    <div>
                        <h4 className='font-semibold mb-2'>6. در پروژه‌ها مسئولیت‌های مشخص و قابل پیگیری بپذیرید</h4>
                        <p>
                            این باعث رشد حرفه‌ای و اعتمادبه‌نفس بیشتر شما خواهد شد.
                        </p>
                    </div>
                    <div>
                        <h4 className='font-semibold mb-2'>7. از بازخورد استقبال کنید، حتی اگر کمی تلخ باشد</h4>
                        <p>
                            چون عاطفی هستید، ممکن است بازخورد جدی را به دل بگیرید. اما بدانید این ابزار رشد است، نه حمله.
                        </p>
                    </div>
                    <div>
                        <h4 className='font-semibold mb-2'>8. درگیر “کمال در روابط” نشوید</h4>
                        <p>
                            همه افراد مثل شما همدل و مهربان نیستند. لازم نیست خود را بابت رفتار سرد دیگران سرزنش کنید.
                        </p>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=" نکاتی ویژه برای محیط‌های حرفه‌ای"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <div className="overflow-x-auto">
                        <table className="w-full text-right border border-gray-300 border-collapse">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border border-gray-300 p-3 font-semibold">تحت فشار کاری</th>
                                    <th className="border border-gray-300 p-3 font-semibold">در برخورد با افراد تند</th>
                                    <th className="border border-gray-300 p-3 font-semibold">در مدیریت پروژه</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        از تکنیک‌های تنفس و نظم شخصی استفاده کنید، لیست بنویسید و اولویت‌بندی را جدی بگیرید
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        به جای اجتناب، با آرامش ولی قاطع بگویید که از چه چیزی ناراحت می‌شوید
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        نقش هماهنگ‌کننده، رابط منابع انسانی یا نماینده تیم برای شما مناسب است، با حفظ چارچوب مشخص
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="رمز موفقیت در تیپ IS"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    افراد با الگوی رفتاری  IS اگر به درستی ویژگی‌های شخصیتی‌شان را هدایت کنند، می‌توانند تبدیل به مؤثرترین افراد تیم، بهترین پل ارتباطی بین دیگران، و عامل انسجام در محیط‌های انسانی باشند. آن‌ها همدل، با‌وفا، پشتیبان و دارای انرژی اجتماعی مثبت‌اند. اما برای موفقیت بلندمدت، به مهارت‌هایی نیاز دارند که از دل خودشناسی می‌جوشد.

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="رمزهای کلیدی موفقیت برای افراد IS"
            >
                <div className='text-gray-800 leading-7 space-y-4'>

                    <div>
                        <p className='font-semibold'>1. قاطعیت در لحظات مهم</p>
                        <p>
                            تمرین کنید که در موقعیت‌هایی که باید تصمیم بگیرید، عقب‌نشینی نکنید.
                            ترس از ناراحت کردن دیگران، نباید مانع اقدام قاطع شود.
                        </p>
                    </div>

                    <div>
                        <p className='font-semibold'>2. مدیریت احساسات + حفظ انسجام درونی</p>
                        <p>
                            شما حساس و عاطفی هستید. موفقیت شما زمانی شکل می‌گیرد که این احساسات را بشناسید،
                            بیان کنید و اجازه ندهید در شما تلنبار شوند.
                        </p>
                    </div>

                    <div>
                        <p className='font-semibold'>3. تمرکز بر نتیجه، نه فقط رضایت دیگران</p>
                        <p>
                            حمایت از دیگران خوب است؛ اما مهم‌تر این است که در کنار آن،
                            به اهداف و نتایج قابل‌سنجش هم توجه داشته باشید.
                        </p>
                    </div>

                    <div>
                        <p className='font-semibold'>4. رشد در سایه تفاوت‌ها</p>
                        <p>
                            در کنار افراد پرانرژی، تصمیم‌گیر و ساختارمند بودن،
                            شما را به نسخه قوی‌تری از خودتان تبدیل می‌کند. از این تفاوت‌ها نترسید.
                        </p>
                    </div>

                    <div>
                        <p className='font-semibold'>5. برنامه‌ریزی دقیق و اولویت‌بندی</p>
                        <p>
                            افراد IS معمولاً درگیر روابط می‌شوند و وظایف را به تعویق می‌اندازند.
                            موفقیت زمانی تضمین می‌شود که شما بدانید چه کاری، در چه زمانی، برای چه هدفی باید انجام شود.
                        </p>
                    </div>

                    <div>
                        <p className='font-semibold'>6. یادگیری «نه» گفتن مؤدبانه</p>
                        <p>
                            رمز رهایی از استهلاک احساسی برای شماست.
                            بپذیرید که همه را نمی‌شود خوشحال نگه داشت و این اشکالی ندارد.
                        </p>
                    </div>

                    <div>
                        <p className='font-semibold'>7. خودآگاهی عاطفی + اعتماد به نفس کلامی</p>
                        <p>
                            حرف‌هایتان مهم است. بیشتر وارد بحث‌ها شوید.
                            بیشتر نظرتان را بگویید. دیده شوید.
                        </p>
                    </div>

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="خلاصه‌وار رمزهای موفقیت شما  IS عزیز"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <div className="overflow-x-auto">
                        <table className="w-full text-right border border-gray-300 border-collapse">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border border-gray-300 p-3 font-semibold">توصیه موفقیت‌آمیز</th>
                                    <th className="border border-gray-300 p-3 font-semibold">ویژگی</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        آن را با قاطعیت ترکیب کن
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        مهربانی بالا                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        آن را با برنامه‌ریزی فردی تکمیل کن
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        میل به همکاری
                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        مراقب باش سوءاستفاده نشود
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        وفاداری                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        مرزهایت را تعریف کن
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        اجتماعی بودن
                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        گاهی هم به دل چالش برو، رشد در آنجاست
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        میل به آرامش
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="پیشنهاد فیلم"
            >
                <div className='text-gray-800 leading-7'>
                    <p className='text-center font-bold'>
                        "The Hundred-Foot Journey 2014"    صد قدم راه
                    </p>
                    <p className='mt-2'>
                        شخصیت “مادام مالوری” ابتدا شخصیتی کنترل‌گر به‌نظر می‌رسد، اما درونش یک  IS رشد یافته و باشکوه است. آرام، مهربان، مؤثر، صبور و در عین حال، قاطع و بالغ در تعاملاتش.
                    </p>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="نحوه تعدیل و تقویت سایر لایه‌ها در تیپ IS"
            >
                <div className='text-gray-800 leading-7'>
                    *چگونه افراد با الگوی  IS می‌توانند متعادل‌تر و مؤثرتر شوند؟
                    ترکیب  IS به‌خودی‌خود آرام، همراه، و اجتماعی است. اما برای تبدیل شدن به یک شخصیت کامل‌تر، پخته‌تر و توانمندتر در چالش‌های زندگی و کسب‌وکار، لازم است ویژگی‌هایی از سه تیپ دیگر یعنی D  تسلط، C  دقت و تحلیل و I  شور و هیجان بیرونی را در خود تقویت کنند.
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="1. تقویت لایه D  تسلط و قاطعیت"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <div className="overflow-x-auto">
                        <table className="w-full text-right border border-gray-300 border-collapse">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border border-gray-300 p-3 font-semibold">تعدیل لازم</th>
                                    <th className="border border-gray-300 p-3 font-semibold">وضعیت فعلی IS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        تمرین ورود محترمانه به بحث‌ها
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        اجتناب از تعارض
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        استفاده از تکنیک "تصمیم ۲۵٪ بهتر از بی‌تصمیمی"
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        تأخیر در تصمیم‌گیری

                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        گاهی پیش‌قدم شدن حتی اگر جمع آماده نباشد
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        پیروی از جمع
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="تمرینات پیشنهادی"
            >
                <ul className='text-gray-800 leading-7 list-disc pr-5 space-y-2'>
                    <li>پروژه‌ای را مستقل رهبری کن حتی اگر کوچک باشد</li>
                    <li>"نه" گفتن به خواسته‌ای که نمی‌خواهی را تمرین کن</li>
                    <li>کتاب پیشنهادی: جرئت بسیار Daring Greatly  از برنه براون</li>
                    <li>فیلم پیشنهادی: The Pursuit of Happyness
                        یادگیری تصمیم‌گیری با جسارت از مسیر پر از سختی.</li>
                </ul>
            </Page>

            <Page
                testResult={testResult}
                title="۲. تقویت لایه C  تحلیل، نظم، دقت، پیش‌بینی"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <div className="overflow-x-auto">
                        <table className="w-full text-right border border-gray-300 border-collapse">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border border-gray-300 p-3 font-semibold">تعدیل لازم</th>
                                    <th className="border border-gray-300 p-3 font-semibold">وضعیت فعلی IS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        بررسی پیامدها و واقعیت‌ها پیش از اقدام
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        تصمیم‌گیری احساسی
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        تحلیل فرآیندها و استانداردها در کنار روابط
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        عمل براساس روابط

                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        بررسی دقیق‌تر جزئیات در کارها و ارتباطات
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        نداشتن جزئی‌نگری
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="تمرینات پیشنهادی"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='text-gray-800 leading-7 list-disc pr-5 space-y-2'>
                        <li>برای تصمیم‌ها یک جدول مقایسه‌ بنویس</li>
                        <li>با تیپ C  یک پروژه مشترک انجام بده</li>
                        <li>هر شب یک کار نیمه‌تمام را با نظم کامل ببند
                        </li>
                        <li>فیلم پیشنهادی: Moneyball 2011  قدرت تحلیل عددی و داده‌محور در کنار تصمیم‌های انسانی.
                        </li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="۳. تعدیل لایه I  اگر بیش‌فعال شده"
            >
                <div className='text-gray-800 leading-7 space-y-4'>

                    <p>در برخی  ISها، مؤلفه  "I " بیش از حد بالا می‌رود. این باعث می‌شود فرد از خود واقعی‌اش دور شود و صرفاً برای تأیید گرفتن، خود را تطبیق دهد.
                    </p>

                    <div className="overflow-x-auto">
                        <table className="w-full text-right border border-gray-300 border-collapse">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border border-gray-300 p-3 font-semibold">راهکار تعادل
                                    </th>
                                    <th className="border border-gray-300 p-3 font-semibold">وضعیت پررنگ I  در  IS
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        تمرین سکوت مؤثر و احترام به فضای جدی
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        خنداندن زیاد برای پذیرفته شدن
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        تمرین گوش دادن فعال و مکث آگاهانه
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        پریدن وسط حرف دیگران برای مشارکت

                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        تمرین رضایت از خود بدون تشویق بیرونی
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        لذت‌بردن از تأیید عمومی
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="جمع‌بندی"
            >
                <div className='text-gray-800 leading-7 space-y-4'>

                    <p>برای فرد  IS، رشد زمانی اتفاق می‌افتد که بتواند:</p>

                    <ul className='text-gray-800 leading-7 list-disc pr-5 space-y-2'>
                        <li>
                            مهارت «نه گفتن»، «بررسی منطقی» و «جسارت در اقدام» را بیاموزد
                        </li>
                        <li>با افراد متفاوت معاشرت آگاهانه داشته باشد و از آن‌ها یاد بگیرد
                        </li>
                        <li>فیلم پیشنهادی: The Secret Life of Walter Mitty
                            زندگی خصوصی والتر میتی
                            یادگیری تعادل میان رؤیاپردازی و اقدام منطقی.
                        </li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="دانش و مهارت‌های مورد نیاز الگوی IS"
            >
                <div className='text-gray-800 leading-7'>
                    از یک فرد خوب به یک فرد حرفه‌ای و مؤثر تبدیل شدن
                    افراد با الگوی رفتاری  IS معمولاً آدم‌های خوش‌قلب، قابل‌اعتماد و اجتماعی هستند. اما این ویژگی‌ها اگر با مهارت‌های مناسب پشتیبانی نشوند، ممکن است باعث استهلاک یا نادیده‌گرفته‌شدن آن‌ها شود. این افراد برای رسیدن به موفقیت‌های جدی در محیط کار، روابط و توسعه فردی، به مجموعه‌ای از مهارت‌های نرم و سخت نیاز دارند.

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="۱. مهارت‌های ارتباطی و بین‌فردی"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <div className="overflow-x-auto">
                        <table className="w-full text-right border border-gray-300 border-collapse">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border border-gray-300 p-3 font-semibold">چرا مهم است؟
                                    </th>
                                    <th className="border border-gray-300 p-3 font-semibold">
                                        مهارت
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        چون  ISها معمولاً مهربان‌اند ولی قاطع نیستند
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        ارتباط مؤثر و قاطع
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        برای جلوگیری از سوءاستفاده یا استهلاک احساسی
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        نه گفتن مؤدبانه

                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        چون به حرف دیگران اهمیت می‌دهند ولی گاهی دچار تحلیل رفتگی می‌شوند
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        گوش دادن فعال
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=" ۲. مهارت‌های خودمدیریتی"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <div className="overflow-x-auto">
                        <table className="w-full text-right border border-gray-300 border-collapse">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border border-gray-300 p-3 font-semibold">
                                        کاربرد
                                    </th>
                                    <th className="border border-gray-300 p-3 font-semibold">
                                        مهارت
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        چون  ISها گاهی درگیر کارهای حاشیه‌ای و روابط زیاد می‌شوند
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        مدیریت زمان و اولویت‌بندی
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        برای اینکه خروجی واقعی از تلاش‌هایشان داشته باشند
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        برنامه‌ریزی هدف‌محور

                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        برای شناسایی و مدیریت بهتر احساسات خود و دیگران
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        هوش هیجانی بالا EQ
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="۳. مهارت‌های شناختی و تصمیم‌گیری"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <div className="overflow-x-auto">
                        <table className="w-full text-right border border-gray-300 border-collapse">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border border-gray-300 p-3 font-semibold">
                                        چرا ضروری است؟
                                    </th>
                                    <th className="border border-gray-300 p-3 font-semibold">
                                        مهارت
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        چون  ISها معمولاً تعلل دارند و از عواقب تصمیم می‌ترسند
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        تصمیم‌گیری در لحظه با کمترین پشیمانی
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        برای جلوگیری از تصمیم‌گیری احساسی یا تأثیرپذیری افراطی
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        تحلیل واقع‌بینانه اطلاعات

                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        به‌خصوص در مواقعی که باید بدون وابستگی نظر دهند
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        تفکر انتقادی و حل مسئله
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="۴. مهارت‌های حرفه‌ای در فضای کاری"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <div className="overflow-x-auto">
                        <table className="w-full text-right border border-gray-300 border-collapse">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border border-gray-300 p-3 font-semibold">
                                        پیشنهاد
                                    </th>
                                    <th className="border border-gray-300 p-3 font-semibold">
                                        مهارت
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        مثل هماهنگ‌کننده منابع انسانی، مسئول رضایت مشتری
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        مدیریت پروژه‌های انسانی / تیمی
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        برای دیده‌شدن مؤثر در محیط کاری، بدون اغراق یا پنهان‌کاری
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        توسعه برند شخصی
                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        حتی برای موقعیت‌های کوچک مثل گزارش‌دادن یا معرفی تیم
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        فن بیان و سخنرانی اثربخش
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="مشاغل مناسب برای افراد با الگوی IS"
            >
                <div className='text-gray-800 leading-7'>
                    شغل‌هایی که با طبیعت رفتاری، ارزش‌ها و انرژی درونی آن‌ها هم‌راستا باشد.
                    افراد  IS انسان‌دوست، حامی، وفادار، آرام و اجتماعی‌اند. این افراد نیاز به فضایی دارند که در آن روابط انسانی معنادار، محیطی باثبات و امکان کمک به دیگران وجود داشته باشد. آن‌ها در محیط‌های پرتنش، رقابتی یا پرفشار معمولاً خسته یا مضطرب می‌شوند و در فضایی که بر ارتباطات صمیمانه و ارزش‌های انسانی تأکید دارد، می‌درخشند.
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="ویژگی‌های شغلی مطلوب برای ISها"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <ul className='text-gray-800 leading-7 list-disc pr-5 space-y-2'>
                        <li>محیط دوستانه، با ارتباطات انسانی گرم
                        </li>
                        <li>امکان حمایت، مشاوره، همراهی و آموزش به دیگران
                        </li>
                        <li>فرآیندهای نسبتاً پایدار و قابل پیش‌بینی
                        </li>
                        <li>تعامل زیاد با افراد اما با استقلال عاطفی کنترل‌شده
                        </li>
                        <li>تمرکز روی بهبود تجربه انسان‌ها مشتری، همکار، دانش‌آموز و...
                        </li>
                        <li>داشتن زمان و آرامش برای انجام کارها با کیفیت
                        </li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="مشاغل مناسب برای افراد با الگوی IS"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <ul className='text-gray-800 leading-7 list-disc pr-5 space-y-2'>
                        <li>
                            <strong>1. مشاور تحصیلی یا مشاور شغلی : </strong> افراد  IS با درک بالا از دیگران، می‌توانند شنونده خوبی برای دغدغه‌های فردی و آینده شغلی یا تحصیلی افراد باشند.

                        </li>
                        <li>
                            <strong> 2. مشاور خانواده یا روان‌درمانگر حمایتی درمانگر حمایتی : </strong> نه در جایگاه تحلیل‌گر عمیق، بلکه در نقش شنونده دلسوز، همراه و انگیزه‌بخش بسیار موفق‌اند.

                        </li>
                        <li>
                            <strong> 3. مربی منابع انسانی یا توسعه فردی : </strong>  ISها می‌توانند حلقه ارتباطی میان سازمان و کارکنان باشند، نیازها را به‌خوبی تشخیص داده و محیطی گرم‌تر برای کار بسازند.

                        </li>
                        <li>
                            <strong>4. کارشناس روابط عمومی / ارتباط با مشتری CRM : </strong> با روحیه همدلی، صبوری و احترام به دیگران، برای حفظ و تقویت رابطه با مشتری بسیار مناسب‌اند.
                        </li>
                        <li>
                            <strong> 5. آموزگار یا مربی در مقاطع پایین‌تر کودکستان، دبستان : </strong> توانمندی فوق‌العاده در ایجاد حس امنیت، ارتباط فردی، و آموزش با عشق و توجه بالا.

                        </li>
                        <li>
                            <strong> 6. کتابداری، مدیریت مراکز فرهنگی یا آموزشی : </strong> محیط‌های آرام، خدمت‌محور و ساختاریافته برای این تیپ فوق‌العاده‌اند.

                        </li>

                        <li>
                            <strong>7. مشاغل مراقبتی یا حمایتی مانند: مددکار اجتماعی، پرستار، درمانگر کودکان استثنایی : </strong> افراد  IS عاطفه و صبر لازم برای کار با بیماران، سالمندان یا نیازمندان را دارند.

                        </li>
                        <li>
                            <strong> 8. مدیر اجرایی در تیم‌های آموزشی، خیریه یا سازمان‌های مردم‌نهاد : </strong> اگر اعتماد به‌نفس کافی کسب کرده باشند، می‌توانند در محیط‌های هدف‌محور انسان‌دوستانه، به‌خوبی در مقام هماهنگ‌کننده عمل کنند.
                        </li>
                        <li>
                            <strong>10. برنامه‌ریز مراسم، مشاور ازدواج یا مشاور روابط اجتماعی : </strong> افرادی که می‌توانند روابط را به‌خوبی درک و مدیریت کنند، بی‌طرفی احساسی را یاد بگیرند و با حمایت عاطفی دیگران را بهبود دهند.
                        </li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="مشاغل پرچالش یا غیرمناسب برای ISها"
            >

                <div className='text-gray-800 leading-7 space-y-4'>
                    <ul className='text-gray-800 leading-7 list-disc pr-5 space-y-2'>
                        <li>فروش سرد یا بازاریابی سخت بدون آموزش یا تمرین قبلی
                        </li>
                        <li>مشاغل نیازمند تصمیم‌گیری سریع در لحظه بدون فرصت مشورت
                        </li>
                        <li>محیط‌های رقابتی و پر از تعارض مثل مدیریت بحران، بازار سرمایه، استراتژی نظامی
                        </li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="مشاغل مناسب برای افراد با الگوی IS"
            >
                <div className="text-gray-800 leading-7">
                    برای پیشنهاد شغلی به تیپ   IS، فقط به «جذابیت اولیه» شغل اکتفا نکنید، بررسی کنید آیا فازهای پیگیری و جزئیات آن کار با توانایی‌هایش هماهنگ است یا خیر؟ در غیر این‌صورت، بهتر است با تیپ مکمل در آن شغل همراه شود.

                </div>
            </Page>

            <Page
                testResult={testResult}
                title="همسر مناسب و نحوه ارتباط مؤثر با او"
            >
                <div className='text-gray-800 leading-7'>
                    افراد  IS همسرانی وفادار، همراه، احساساتی، حمایت‌گر و بسیار انعطاف‌پذیر هستند. آن‌ها اغلب به نیازهای دیگران بیش از خودشان توجه دارند. در نتیجه اگر همسرشان فرد درستی نباشد، ممکن است دچار فرسودگی عاطفی، وابستگی یا حتی سرخوردگی شوند.
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="ویژگی‌های مناسب همسر فرد IS"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <div className="overflow-x-auto">
                        <table className="w-full text-right border border-gray-300 border-collapse">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border border-gray-300 p-3 font-semibold">
                                        چرا مهم است؟
                                    </th>
                                    <th className="border border-gray-300 p-3 font-semibold">
                                        ویژگی
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        چون  ISها گاهی در تصمیم‌گیری یا مدیریت تعارض، عقب می‌کشند
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        قاطع، متکی‌به‌نفس و تصمیم‌گیرنده
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        چون  ISها برای محبت، وفاداری و دیده‌شدن انرژی می‌گذارند
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        مهربان و قدرشناس
                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        چون  ISها معمولاً بیشتر در لحظه‌اند و به فردی نیاز دارند که چشم‌انداز دهد
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        بلندبین، با برنامه و آینده‌نگر
                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        چون  IS نیاز دارد شنیده شود، بدون اینکه مورد قضاوت قرار گیرد
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        اهل گفت‌وگو و توجه به احساسات
                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        چون امنیت روانی برای  IS مهم‌ترین اصل در رابطه است
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        متعهد و مسئول‌پذیر
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="نکاتی که همسر فرد IS باید بداند"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <ul className='text-gray-800 leading-7 list-disc pr-5 space-y-2'>
                        <li>1. او ممکن است "نه" نگوید، اما دلخور شود. حتماً از او نظر بخواهید.
                        </li>
                        <li>2. به تحسین، تشکر و کلام محبت‌آمیز واکنش مثبت نشان می‌دهد. از آن غافل نشوید.
                        </li>
                        <li>3. اگر عقب‌نشینی می‌کند یا سکوت می‌کند، لزوماً راضی نیست. دنبال گفتگو بروید.
                        </li>
                        <li>4. شما باید تصمیم‌گیر اول باشید، اما تصمیمات را با او مطرح کنید تا احساس بی‌اهمیتی نکند.
                        </li>
                        <li>5. مراقب باشید حمایت او را با خدمت‌گزاری بی‌حد اشتباه نگیرید؛ او ممکن است خسته شود.
                        </li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="نکاتی که فرد باید در زندگی زناشویی رعایت کند"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='text-gray-800 leading-7 list-disc pr-5 space-y-2'>
                        <li>1. همه‌چیز با گذشت و مهربانی حل نمی‌شود، گاهی باید حد و مرز گذاشت.
                        </li>
                        <li>2. نیازهای خود را با صدای رسا و واضح بیان کنید. منتظر نمانید که دیگری حدس بزند.
                        </li>
                        <li>3. تعارض را پنهان نکنید؛ گفت‌وگوهای سالم حتی اگر سخت باشند، رابطه را رشد می‌دهند.
                        </li>
                        <li>4. استقلال خود را حفظ کنید. حتی در زندگی مشترک، شما "یک فرد کامل" هستید.
                        </li>
                        <li>5. اگر از چیزی ناراحت شدید، به جای سکوت، راه گفتگو را انتخاب کنید.
                        </li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="ارتباط مؤثر والدین IS با فرزندان و بالعکس"
            >
                <div className='text-gray-800 leading-7'>
                    والدین با الگوی رفتاری  IS معمولاً مهربان، صبور، مراقب و حمایت‌گر هستند. آن‌ها اغلب سعی می‌کنند محیطی آرام، عاطفی و امن برای فرزندان خود فراهم کنند. با این حال، همین ویژگی‌ها اگر تعدیل نشده باقی بمانند، می‌توانند چالش‌هایی هم ایجاد کنند؛ مانند وابستگی زیاد فرزندان، نداشتن مرزهای روشن، یا تربیت مبتنی بر احساس به‌جای منطق.
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="ویژگی‌های والد IS در تعامل با فرزندان"
            >
                <div className='text-gray-800 leading-7 space-y-4'>
                    <div className="overflow-x-auto">
                        <table className="w-full text-right border border-gray-300 border-collapse">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border border-gray-300 p-3 font-semibold">
                                        خطر احتمالی
                                    </th>
                                    <th className="border border-gray-300 p-3 font-semibold">
                                        ویژگی مثبت
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        ناتوانی در تعیین مرزهای رفتاری برای کودک
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        صبوری، محبت و پذیرش بالا
                                    </td>
                                </tr>
                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        جلوگیری از تجربه‌های رشد و استقلال فرزند
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        تمایل زیاد به محافظت
                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        عدم آموزش مدیریت اختلاف به فرزندان
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        اجتناب از تعارض و تنش
                                    </td>
                                </tr>

                                <tr>
                                    <td className="border border-gray-300 p-3">
                                        بی‌توجهی به نیازهای خود یا نقش والد بودن
                                    </td>
                                    <td className="border border-gray-300 p-3">
                                        تمایل به خوشحال نگه داشتن همه
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title=" توصیه‌هایی برای والدین IS"
            >
                <div className='text-gray-800 leading-7'>
                    <ul className='text-gray-800 leading-7 list-disc pr-5 space-y-2'>
                        <li>1. "دوست خوب بودن" کافی نیست، "والد مسئول" هم باید باشید.
                        </li>
                        <li>   گاهی باید نه بگویید، قانون بگذارید و عواقب رفتارها را به کودک نشان دهید.
                        </li>
                        <li>فرزندان را برای استقلال تربیت کنید، نه برای جلب رضایت.
                            نگذارید مهربانی شما باعث شود کودک وابسته یا بی‌انگیزه بار بیاید.
                        </li>
                        <li>3. خشم خود را پنهان نکنید، بلکه آن را سالم ابراز کنید.
                        </li>
                        <li>   فرزندان باید یاد بگیرند که ابراز احساسات منفی هم طبیعی است، اگر محترمانه باشد.
                        </li>
                        <li>
                            4. احساسات و نیازهای خودتان را هم جدی بگیرید.
                            فرزند شما باید بداند پدر/مادر هم انسانی مستقل با نیازهای واقعی است
                        </li>
                        <li>5. حد و مرزهای روشن بگذارید و در اجرای آن‌ها قاطع باشید.
                            با ثبات در قوانین، کودک حس امنیت رفتاری پیدا می‌کند.
                        </li>
                    </ul>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="فرزندان چگونه با والدین IS ارتباط مؤثر برقرار کنند؟"
            >

                <div className='text-gray-800 leading-7'>
                    <p>
                        فرزندان چنین والدینی باید یاد بگیرند:
                    </p>

                    <ul className='text-gray-800 leading-7 list-disc pr-5 space-y-2'>
                        <li>در قبال مهربانی والدین، قدردان باشند.
                        </li>
                        <li>احساسات و نیازهای خود را صادقانه بگویند تا سوءبرداشت نشود.
                        </li>
                        <li>در صورت سختگیری گاه‌به‌گاه، والد  IS را سرزنش نکنند؛ آن‌ها دارند رشد می‌کنند.
                        </li>
                        <li>در رفتارشان تعادل بین آزادی و مسئولیت‌پذیری را حفظ کنند.
                        </li>
                        <li>گاهی به جای گرفتن حمایت، نقش حمایتگر را برای والدشان بازی کنند.
                        </li>
                    </ul>
                </div>
            </Page>
        </>
    )
}

export default IS